import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useBlocker, useNavigate } from 'react-router-dom';
import { API_URL } from '../../../config/constants';
import createIconImg from '../../../images/createIcon.png';
import YouWereEditing from '../../components/YouWereEditing';
import { useSelector } from 'react-redux';
import CustomCheckbox from '../../components/CustomCheckbox';
import sortingBtnIconImg from '../../../images/sortingBtnIcon.png'
import Select from 'react-select';
import arrowIconImg from '../../../images/filledArrowIcon.png';

function ShowUserRank({ ranksArr }) {
    const { userRank, organization, privilege, login } = useSelector((state) => state.session);
    const [rankList, setRankList] = useState([]);
    const [changed, setChanged] = useState(false);
    const [updatedArr, setUpdatedArr] = useState([]);
    const [newRowsArr, setNewRowsArr] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const defaultSorting = {
        organization: 'neutral',
        members: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        sumData: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        detailedData: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        model: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        userRank: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        sumDataStruct: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        detailedDataStruct: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        sumDataView: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        detailedDataView: { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
        //통계분석 기본값 추가
        // StatisticView : { read: 'neutral', edit: 'neutral', delete: 'neutral', beyondOrg: 'neutral' },
    };
    const [sorting, setSorting] = useState(defaultSorting);
    const navigate = useNavigate();
    const userRankWithId = ranksArr.map(el => {
        const { rankId, ...rest } = el;
        return ({ "rankId": rankId, "data": rest });
    });

    async function getOrg() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getOrg`);
        setOrganizations(response.data.map(el => ({ id: el.id, name: el.name })));
    };

    const onCreateNewRow = e => {
        const rankNos = rankList.map(x => x.data.rank);
        const newRankNos = newRowsArr.map(x => x.data.rank);
        const maxRank = Math.max(...rankNos, ...newRankNos);
        const dnRank = userRank <= 20 ? -1 : maxRank + 1;
        if (dnRank > 100) {
            window.alert('만들 수 있는 사용권한 수를 초과했습니다.');
            return;
        }
        setNewRowsArr(prev => [...prev, {
            data: {
                rank: dnRank,
                name: '',
                organization: userRank <= 20 ? -1 : organization,
                members: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                sumData: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                detailedData: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                model: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                userRank: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                sumDataStruct: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                detailedDataStruct: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                sumDataView: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                detailedDataView: {
                    read: false,
                    edit: false,
                    delete: false,
                    beyondOrg: false,
                },
                //나중에 여기에 통계분석 추가
                // StatisticView: {
                //     read : false,
                //     edit : false,
                //     delete : false,
                //     beyondOrg : false,
                // }
            }
        }]);
        setChanged(true);
    }
    console.log(newRowsArr)
    // 저장 버튼 이벤트
    const handleCreateObject = async e => {
        e.preventDefault();
        // rank 항목 유일성 체크
        // const rankArr = rankList.map(el => el.data.rank);
        // if (newValue !== null) rankArr.push(newValue.rank);
        // const isDup = rankArr.some(function (x) {
        //     return !(x > 10 && x <= 30) && rankArr.indexOf(x) !== rankArr.lastIndexOf(x);
        // });
        // if (isDup) {
        //     window.alert('RANK는 중복될 수 없습니다.')
        //     return;
        // }
        // const dataArr = rankList.map(el => el.data);
        const isVacant = newRowsArr.some(function (newRow) {
            const nrData = newRow.data;
            return nrData.rank < 0 || nrData.name.length < 1
        });
        if (isVacant) {
            window.alert('신규생성랭크 데이터 중 입력되지 않은 값이 있습니다.');
            return;
        }
        const updArr = rankList.filter(x => updatedArr.includes(x.rankId)).map(el => {
            const dataObj = {...el.data};
            const { organization, Organization, ...rest } = dataObj;
            return ({ rankId: el.rankId, data: { ...rest } });
        });
        const newArr = newRowsArr.map(y => ({ ...y.data, organization: y.data.organization === -1 ? null : y.data.organization }));
        // 수정 사항 이전 rank(PK)체크 후 해당 데이터만 전송
        await axios.post(`${API_URL}/monitoring-manage/updateRanks`, { updatedData: updArr, newData: newArr }).then(res => {
            if (res.data.success) {
                // onReturnDefault(e);
                navigate(0);
            } else {
                console.error(res.data.error);
            }
        }).catch(err => console.error(err));

    };
    // 초기화 버튼 이벤트
    const onReset = e => {
        e.preventDefault();
        const adminRanks = userRankWithId.filter(el => el.data.rank <= 20).sort((a, b) => a.data.rank - b.data.rank);
        const orgRanks = userRankWithId.filter(el => el.data.rank > 20 && el.data.rank <= 100);
        const noOrgRanks = userRankWithId.filter(el => el.data.rank > 100).sort((a, b) => a.data.rank - b.data.rank);
        setRankList([
            ...adminRanks,
            ...orgRanks.sort((a, b) => {
                if (a.data.organization > b.data.organization) {
                    return 1;
                } else if (a.data.organization < b.data.organization) {
                    return -1;
                } else {
                    return a.data.rank - b.data.rank;
                }
            }),
            ...noOrgRanks,
        ]);
        setNewRowsArr([]);
        setUpdatedArr([]);
        setChanged(false);
        setSorting(defaultSorting);
    };
    console.log(rankList)

    const onSorting = (e, firstKey, secondKey = null) => {
        e.preventDefault();
        const changeVal = (prevVal) => {
            switch (prevVal) {
                case 'asc': return 'desc';
                case 'desc': return 'asc';
                default: return 'desc';
            }
        }
        if (secondKey) {
            const nextSortDir = changeVal(sorting[firstKey][secondKey]);
            setRankList(prev => prev.sort((a, b) => {
                switch (nextSortDir) {
                    case 'asc':
                        return a["data"][firstKey][secondKey] - b["data"][firstKey][secondKey];
                    case 'desc':
                        return b["data"][firstKey][secondKey] - a["data"][firstKey][secondKey];

                }
            }))
            setSorting(prev => {
                return ({
                    ...prev,
                    [firstKey]: {
                        ...prev[firstKey],
                        [secondKey]: nextSortDir
                    }
                });
            })
        } else {
            const nextSortDir = changeVal(sorting[firstKey]);
            setRankList(prev => prev.sort((a, b) => {
                switch (nextSortDir) {
                    case 'asc':
                        return a["data"][firstKey] - b["data"][firstKey];
                    case 'desc':
                        return b["data"][firstKey] - a["data"][firstKey];

                }
            }))
            setSorting(prev => {
                return ({
                    ...prev,
                    [firstKey]: nextSortDir
                });
            })
        }

    };

    const printPrivilegeCells = (rankData, index, isNew = false) => {
        const privArr = ["members", "sumData", "detailedData", "userRank", "model", "sumDataStruct", "detailedDataStruct", "sumDataView", "detailedDataView"]; //"StatisticView" 여기에 나중에 통계분석  추가하기
        return (privArr.map((priv, privIdx) => (<li className={`col ${priv}`} key={`rankPrivLi_${rankData.rankId}_${privIdx}`}>
            <ul className='forPriv'>
                <li className='privChkboxLi'>
                    <CustomCheckbox
                        id={`${rankData.rankId}_${priv}_read`}
                        checked={rankData.data[priv]["read"]}
                        onChange={e => {
                            if (isNew) {
                                let copyArr = [...newRowsArr];
                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], read: !copyArr[index]["data"][priv]["read"] } } };
                                setNewRowsArr(copyArr);
                                setChanged(true);
                            } else {

                                let copyArr = [...rankList];
                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], read: !copyArr[index]["data"][priv]["read"] } } };
                                setRankList(copyArr);
                                setUpdatedArr(prev => {
                                    const retArr = [...prev, copyArr[index].rankId];
                                    return [...new Set(retArr)];
                                });
                                setChanged(true);
                            }
                        }}
                        disabled={!privilege?.userRank.edit || !privilege[priv]["read"]}
                        value={rankData.data[priv]["read"]}
                    />
                </li>
                <li className='privChkboxLi'>
                    <CustomCheckbox
                        id={`${rankData.rankId}_${priv}_edit`}
                        checked={rankData.data[priv]["edit"]}
                        onChange={e => {
                            if (isNew) {
                                let copyArr = [...newRowsArr];
                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], edit: !copyArr[index]["data"][priv]["edit"] } } };
                                setNewRowsArr(copyArr);
                                setChanged(true);
                            } else {
                                let copyArr = [...rankList];
                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], edit: !copyArr[index]["data"][priv]["edit"] } } };
                                setRankList(copyArr);
                                setChanged(true);
                                setUpdatedArr(prev => {
                                    const retArr = [...prev, copyArr[index].rankId];
                                    return [...new Set(retArr)];
                                });
                            }
                        }}
                        value={rankData.data[priv]["edit"]}
                        disabled={!privilege?.userRank.edit || !privilege[priv]["edit"]}
                    />
                </li>
                <li className='privChkboxLi'>
                    <CustomCheckbox
                        id={`${rankData.rankId}_${priv}_delete`}
                        checked={rankData.data[priv]["delete"]}
                        onChange={e => {
                            if (isNew) {
                                let copyArr = [...newRowsArr];
                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], delete: !copyArr[index]["data"][priv]["delete"] } } };
                                setNewRowsArr(copyArr);
                                setChanged(true);
                            } else {

                                let copyArr = [...rankList];
                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], delete: !copyArr[index]["data"][priv]["delete"] } } };
                                setRankList(copyArr);
                                setChanged(true);
                                setUpdatedArr(prev => {
                                    const retArr = [...prev, copyArr[index].rankId];
                                    return [...new Set(retArr)];
                                });
                            }
                        }}
                        value={rankData.data[priv]["delete"]}
                        disabled={!privilege?.userRank.edit || !privilege[priv]["delete"]}
                    />
                </li>
                {
                    userRank <= 20 ? <li className='privChkboxLi'>
                        <CustomCheckbox
                            id={`${rankData.rankId}_${priv}_beyondOrg`}
                            checked={rankData.data[priv]["beyondOrg"]}
                            onChange={e => {
                                if (isNew) {
                                    let copyArr = [...newRowsArr];
                                    copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], beyondOrg: !copyArr[index]["data"][priv]["beyondOrg"] } } };
                                    setNewRowsArr(copyArr);
                                    setChanged(true);
                                } else {
                                    let copyArr = [...rankList];
                                    copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [priv]: { ...copyArr[index]["data"][priv], beyondOrg: !copyArr[index]["data"][priv]["beyondOrg"] } } };
                                    setRankList(copyArr);
                                    setChanged(true);
                                    setUpdatedArr(prev => {
                                        const retArr = [...prev, copyArr[index].rankId];
                                        return [...new Set(retArr)];
                                    });
                                }
                            }}
                            value={rankData.data[priv]["beyondOrg"]}
                            disabled={!privilege?.userRank.edit || !privilege[priv]["beyondOrg"]}
                        />
                    </li> : null
                }
            </ul>
        </li>)
        ))
    }

    useEffect(() => {
        const adminRanks = userRankWithId.filter(el => el.data.rank <= 20).sort((a, b) => a.data.rank - b.data.rank);
        const orgRanks = userRankWithId.filter(el => el.data.rank > 20 && el.data.rank <= 100);
        const noOrgRanks = userRankWithId.filter(el => el.data.rank > 100).sort((a, b) => a.data.rank - b.data.rank);
        setRankList([
            ...adminRanks.map(el => ({ ...el, data: { ...el.data, organization: -1 } })),
            ...orgRanks.sort((a, b) => {
                if (a.data.organization > b.data.organization) {
                    return 1;
                } else if (a.data.organization < b.data.organization) {
                    return -1;
                } else {
                    return a.data.rank - b.data.rank;
                }
            }),
            ...noOrgRanks.map(el => ({ ...el, data: { ...el.data, organization: -1 } })),
        ]);
    }, [ranksArr]);

    useEffect(() => {
        getOrg();
    }, [])


    const [blockPopup, setBlockPopup] = useState(false);
    let blocker = useBlocker(({ currentLocation, nextLocation }) =>
        changed && login &&
        currentLocation.pathname !== nextLocation.pathname);

    useEffect(() => {
        if (blocker.state === "blocked") {
            setBlockPopup(true);
        } else {
            setBlockPopup(false);
        }
    }, [blocker.state])

    const orgOptArr = organizations.map(el => ({ label: el.name, value: el.id }));
    return (
        <React.Fragment>
            <div className='showUserRankArea'>
                <p className='path'>데이터 구조 관리<span className='below'>{'>'}</span>유저 랭크</p>
                <h2 className='pageTitle'>유저 랭크</h2>
                <div className='userRankTblArea'>
                    {/* <div className='hintBtn'>
                        ?
                        <div className='hintMsg'><p>셀을 직접 클릭하여 수정이 가능합니다.</p></div>
                    </div> */}
                    <ul className='userRankTbl'>
                        <li className='row th'>
                            <ul>
                                {
                                    userRank <= 20 ?
                                        <li className='col rank'>랭크</li> : null
                                }
                                <li className='col name'>사용 권한</li>
                                {
                                    userRank <= 20 ?
                                        <li className='col organization'>
                                            <span>소속</span>
                                            <button className={`sortingBtn ${sorting.organization}`} onClick={e => onSorting(e, 'organization')}>
                                                <img src={sortingBtnIconImg} alt={'정렬'} />
                                            </button>
                                        </li> : null
                                }
                                <li className='col members'>
                                    <ul>
                                        <li>회원 관리</li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.members.read}`} onClick={e => onSorting(e, 'members', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.members.edit}`} onClick={e => onSorting(e, 'members', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.members.delete}`} onClick={e => onSorting(e, 'members', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.members.beyondOrg}`} onClick={e => onSorting(e, 'members', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col sumData'>
                                    <ul>
                                        <li>

                                            공정 요약
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.sumData.read}`} onClick={e => onSorting(e, 'sumData', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.sumData.edit}`} onClick={e => onSorting(e, 'sumData', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.sumData.delete}`} onClick={e => onSorting(e, 'sumData', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.sumData.beyondOrg}`} onClick={e => onSorting(e, 'sumData', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col detailedData'>
                                    <ul>
                                        <li>

                                            세부 데이터
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.detailedData.read}`} onClick={e => onSorting(e, 'detailedData', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.detailedData.edit}`} onClick={e => onSorting(e, 'detailedData', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.detailedData.delete}`} onClick={e => onSorting(e, 'detailedData', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.detailedData.beyondOrg}`} onClick={e => onSorting(e, 'detailedData', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col userRank'>
                                    <ul>
                                        <li>

                                            유저 랭크
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.userRank.read}`} onClick={e => onSorting(e, 'userRank', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.userRank.edit}`} onClick={e => onSorting(e, 'userRank', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.userRank.delete}`} onClick={e => onSorting(e, 'userRank', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.userRank.beyondOrg}`} onClick={e => onSorting(e, 'userRank', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col model'>
                                    <ul>
                                        <li>

                                            모델
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.model.read}`} onClick={e => onSorting(e, 'model', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.model.edit}`} onClick={e => onSorting(e, 'model', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.model.delete}`} onClick={e => onSorting(e, 'model', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.model.beyondOrg}`} onClick={e => onSorting(e, 'model', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col sumDataStruct'>
                                    <ul>
                                        <li>

                                            요약 데이터 구조
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.sumDataStruct.read}`} onClick={e => onSorting(e, 'sumDataStruct', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.sumDataStruct.edit}`} onClick={e => onSorting(e, 'sumDataStruct', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.sumDataStruct.delete}`} onClick={e => onSorting(e, 'sumDataStruct', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.sumDataStruct.beyondOrg}`} onClick={e => onSorting(e, 'sumDataStruct', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col detailedDataStruct'>
                                    <ul>
                                        <li>

                                            세부 데이터 구조
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataStruct.read}`} onClick={e => onSorting(e, 'detailedDataStruct', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataStruct.edit}`} onClick={e => onSorting(e, 'detailedDataStruct', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataStruct.delete}`} onClick={e => onSorting(e, 'detailedDataStruct', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataStruct.beyondOrg}`} onClick={e => onSorting(e, 'detailedDataStruct', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col sumDataView'>
                                    <ul>
                                        <li>

                                            공정 요약 뷰
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.sumDataView.read}`} onClick={e => onSorting(e, 'sumDataView', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.sumDataView.edit}`} onClick={e => onSorting(e, 'sumDataView', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.sumDataView.delete}`} onClick={e => onSorting(e, 'sumDataView', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.sumDataView.beyondOrg}`} onClick={e => onSorting(e, 'sumDataView', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li className='col detailedDataView'>
                                    <ul>
                                        <li>

                                            세부 데이터 뷰
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataView.read}`} onClick={e => onSorting(e, 'detailedDataView', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataView.edit}`} onClick={e => onSorting(e, 'detailedDataView', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataView.delete}`} onClick={e => onSorting(e, 'detailedDataView', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.detailedDataView.beyondOrg}`} onClick={e => onSorting(e, 'detailedDataView', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li>

                                {/* <li className='col StatisticView'>
                                    <ul>
                                        <li>
                                            통계 분석
                                        </li>
                                        <li>
                                            <ul>
                                                <li>
                                                    <span>접근</span>
                                                    <button className={`sortingBtn ${sorting.StatisticView.read}`} onClick={e => onSorting(e, 'StatisticView', 'read')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>수정</span>
                                                    <button className={`sortingBtn ${sorting.StatisticView.edit}`} onClick={e => onSorting(e, 'StatisticView', 'edit')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                <li>
                                                    <span>삭제</span>
                                                    <button className={`sortingBtn ${sorting.StatisticView.delete}`} onClick={e => onSorting(e, 'StatisticView', 'delete')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li>
                                                {userRank <= 20 ? <li>
                                                    <span>전체</span>
                                                    <button className={`sortingBtn ${sorting.StatisticView.beyondOrg}`} onClick={e => onSorting(e, 'StatisticView', 'beyondOrg')}>
                                                        <img src={sortingBtnIconImg} alt={'정렬'} />
                                                    </button>
                                                </li> : null}
                                            </ul>
                                        </li>
                                    </ul>
                                </li> */}
                            </ul>
                        </li>
                        {
                            rankList.map((element, index, array) => {
                                return (
                                    <li key={`rankLi_${index}`} className='row'>
                                        <ul>
                                            {
                                                userRank <= 20 ?
                                                    <li className='col rank'>
                                                        <div className='inputArea'>
                                                            <input type="text" value={element.data.rank} name='rank' disabled={!privilege?.userRank.edit} onChange={
                                                                (e) => {
                                                                    let copyArr = [...rankList];
                                                                    copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [e.target.name]: e.target.value } };
                                                                    setRankList(copyArr);
                                                                    setChanged(true);
                                                                    setUpdatedArr(prev => {
                                                                        const retArr = [...prev, copyArr[index].rankId];
                                                                        return [...new Set(retArr)];
                                                                    });
                                                                }
                                                            } />
                                                        </div>
                                                    </li> : null
                                            }
                                            <li className='col name'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.data.name} name='name' disabled={!privilege?.userRank.edit} onChange={
                                                        (e) => {
                                                            let copyArr = [...rankList];
                                                            copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [e.target.name]: e.target.value } };
                                                            setRankList(copyArr);
                                                            setChanged(true);
                                                            setUpdatedArr(prev => {
                                                                const retArr = [...prev, copyArr[index].rankId];
                                                                return [...new Set(retArr)];
                                                            });
                                                        }
                                                    } />
                                                </div>
                                            </li>
                                            {
                                                userRank <= 20 ?
                                                    <li className='col organization'>
                                                        {element.data.Organization?.name ?? '-'}
                                                    </li> : null
                                            }
                                            {
                                                printPrivilegeCells(element, index)
                                            }
                                        </ul>
                                    </li>
                                );
                            })
                        }
                        {
                            newRowsArr.map((element, index, array) => {
                                return (
                                    <li key={`newRankLi_${index}`} className='row newRow'>
                                        <ul>
                                            {
                                                userRank <= 20 ?
                                                    <li className='col rank'>
                                                        <div className='inputArea'>
                                                            <input type="text" value={element.data.rank < 0 ? '' : element.data.rank} name='rank' disabled={!privilege?.userRank.edit} onChange={
                                                                (e) => {
                                                                    let copyArr = [...newRowsArr];
                                                                    copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [e.target.name]: e.target.value } };
                                                                    setNewRowsArr(copyArr);

                                                                }
                                                            } />
                                                        </div>
                                                    </li> : null
                                            }
                                            <li className='col name'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.data.name} name='name' disabled={!privilege?.userRank.edit} onChange={
                                                        (e) => {
                                                            let copyArr = [...newRowsArr];
                                                            copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, [e.target.name]: e.target.value } };
                                                            setNewRowsArr(copyArr);

                                                        }
                                                    } />
                                                </div>
                                            </li>
                                            {
                                                userRank <= 20 ?
                                                    <li className='col organization'>
                                                        <Select
                                                            options={orgOptArr}
                                                            onChange={sel => {
                                                                let copyArr = [...newRowsArr];
                                                                copyArr[index] = { ...copyArr[index], data: { ...copyArr[index].data, organization: sel.value } };
                                                                setNewRowsArr(copyArr);
                                                            }}
                                                            menuPlacement='auto'
                                                            value={orgOptArr.find(el => el.value === newRowsArr[index]["data"]["organization"])}
                                                            isSearchable={false}
                                                            maxMenuHeight={'225px'}
                                                            placeholder={'소속'}
                                                            classNames={{
                                                                control: (state) => 'control',
                                                                container: (state) => 'selectBox',
                                                                dropdownIndicator: (state) => 'arrow',
                                                                menu: (state) => 'options',
                                                                option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                                singleValue: (state) => 'singleVal',
                                                                valueContainer: (state) => 'valueContainer',
                                                                placeholder: (state) => 'placeholder'
                                                            }}
                                                            components={{
                                                                DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                                IndicatorSeparator: (state) => null,
                                                            }}
                                                        />
                                                    </li> : null
                                            }
                                            {
                                                printPrivilegeCells(element, index, true)
                                            }
                                        </ul>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
                <div className='btnsArea cscBtns'>
                    <button className={'createBtn'} onClick={onCreateNewRow}>추가<img src={createIconImg} alt={"추가"} /></button>
                    <button className='editBtn' onClick={handleCreateObject} disabled={!changed}>저장</button>
                    <button className='cancelBtn' onClick={onReset} disabled={!changed}>취소</button>
                </div>
            </div>
            <YouWereEditing
                isOpen={blockPopup}
                onRequestClose={e => { e.preventDefault(); blocker.reset(); }}
                onSubmit={e => { e.preventDefault(); blocker.proceed(); }}
            />
        </React.Fragment>
    );
}

export default ShowUserRank;